//@flow
import { createSelector } from 'reselect';
import * as Immutable from 'immutable';
import { clientIdSelector } from 'common/redux/selectors/sessionSelector';
import {
    clientSelector,
    teamIdQuerySelector
} from 'common/redux/selectors/queryParamsSelectors';

const getUserHeadersFromParserSettings = state =>
    state.team.getIn([
        'records',
        'taskProfile',
        'entity',
        'csvParserSettings',
        'userHeaders'
    ]);

export const getNonEditableColumnsSelector = createSelector(
    [getUserHeadersFromParserSettings],
    userHeaders => {
        let columnBuffer = [];

        if (userHeaders) {
            userHeaders.forEach((headerValue, headerKey) => {
                if (!headerValue.editable) {
                    columnBuffer = [...columnBuffer, headerKey];
                }
            });
        }
        return Immutable.fromJS(columnBuffer);
    }
);

export const teamsSelector = createSelector(
    [clientSelector, clientIdSelector, state => state.team],
    (clientId, defaultClientId, team) => {
        return team.getIn(
            ['records', clientId || defaultClientId],
            Immutable.Map()
        );
    }
);

export const getTeamFromQuery = createSelector(
    [clientIdSelector, teamIdQuerySelector, state => state.team],
    (clientId: ?string, teamId: ?string, teamStore: Object) => {
        if (clientId && teamId) {
            return teamStore.getIn(['records', clientId, teamId]);
        }
        return null;
    }
);

const getLocalMatchObject = (state, props, externalMatch) => {
    return props.match && props.match.isExact ? props.match : externalMatch;
};

export const getTeamNameAndColor = createSelector(
    [
        clientIdSelector,
        getLocalMatchObject,
        teamIdQuerySelector,
        getTeamFromQuery,
        state => state.batch
    ],
    (clientId, localMatch, teamId, team, batchRecord) => {
        var result = {
            team: null,
            color: null
        };
        if (!localMatch) {
            return result;
        }
        var { batchId } = localMatch.params;
        var localClientId = clientId;
        if (!clientId) {
            ({ localClientId } = localMatch.params);
        }
        if (!localClientId || !batchId) {
            return result;
        }

        // state.batch can be `undefined` as we inject batch reducer
        // only on dispatcher screen
        var batch = batchRecord?.getIn([
            'records',
            localClientId,
            batchId,
            'batch'
        ]);

        if (batch) {
            var teamObject = batch.getTeamObject();
            result.team = teamObject ? teamObject.name : null;
            result.color = teamObject ? teamObject.color : null;
        } else {
            if (teamId && team) {
                result.team = team.get('name');
                result.color = team.get('color');
            }
        }
        return result;
    }
);
